module.exports = __webpack_public_path__ + "static/media/ill_preventivmedel.fd9a2280.svg";